export default __webpack_public_path__ + "static/foregroundDirectors-d10b16955efb5fbe16a00f5e4f0fe79e.webp";